module.exports = __webpack_public_path__ + "static/p08_cerditoBottom-255a5d03aeba91ba459e87e63e87e284.png";